module.exports = __webpack_public_path__ + "img/book-pink.cf506cf9.svg";